import React from 'react';
import LocationTemplate from './LocationTemplate';

const MountOlivePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Mount Olive"
      stateName="North Carolina"
      countyName="Wayne"
      zipCodes={["28365"]}
      latitude={35.1971}
      longitude={-78.0683}
      population={4705}
      historicalFact="Home to Mount Olive Pickle Company, founded in 1926, and Mount Olive College."
      nearbyTowns={[
        "Goldsboro, NC",
        "Fremont, NC",
        "Pikeville, NC",
        "Kinston, NC",
        "Seven Springs, NC",
        "Faison, NC",
        "Calypso, NC",
        "Warsaw, NC"
      ]}
    />
  );
};

export default MountOlivePage;